import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  isLoading = new BehaviorSubject<boolean>(false);
  private loadingComponents = new BehaviorSubject<number>(0)

  constructor() {
    this.loadingComponents.subscribe(queue => {
      if (queue > 0) {
        this.isLoading.next(true);
      }
      else {
        this.isLoading.next(false);
      }
    })
  }

  startLoader() {
    let loadingQueue = this.loadingComponents.value
    loadingQueue++
    this.loadingComponents.next(loadingQueue);
  }

  stopLoader() {
    let loadingQueue = this.loadingComponents.value;
    loadingQueue+=(-1)
    this.loadingComponents.next(loadingQueue);
  }
}
